export const PRACTICE = {
  street: "15 rue Charles de Gaulle",
  postcode: "89250",
  city: "Chemilly-sur-Yonne",
  address: "15 rue Charles de Gaulle, 89250 Chemilly-sur-Yonne",
  googleBusinessUrl: "https://maps.app.goo.gl/gQbNEsYZANeaTEzD6",
  sessionPrice: 65,
  currency: "EUR",
  sessionPriceLabel: "65 € par séance",
  hoursLabel: "Lundi-vendredi : 9h–20h · Samedi : 9h–18h · Dimanche : 9h–14h",
  hoursMultiline: "Lun-Ven : 9h–20h\nSam : 9h–18h\nDim : 9h–14h",
} as const;